import React, { useState, useEffect, ReactElement } from 'react';
import { actions as reportsActions } from '../../actions/reportsActions';
import { useDispatch } from 'react-redux';
import * as types from '../../constants/actionTypes';
import Notification from '../Common/Notification';
import type { Dispatch } from 'redux';
import GeneralReports from './components/GeneralReports/GeneralReports';
import { CUSTOMER_ROLES } from '../../constants/roles';
import { connect } from 'react-redux';

import { GlobalStyle, PageWrapper, ReportsPageTitle, ReportsTab } from './styles';
import ScheduledReports from './components/ScheduledReports/ScheduledReports';

interface TabData {
	id: number;
	label: string;
	component: JSX.Element;
	icon: string;
}

interface ReportsPageProps {
	userRole: string;
}

const ReportsPage = (props: ReportsPageProps): ReactElement => {
	const [activeTab, setActiveTab] = useState<number>(1);
	const [tabs, setTabs] = useState<TabData[]>([
		// { id: 0, label: "Favorite Reports", component: <div>Loading...</div>, icon: 'pi-heart' },
		{
			id: 1,
			label: 'General Reports',
			component: <div>Loading...</div>,
			icon: 'pi-chart-bar',
		},
		{
			id: 2,
			label: 'Moderator Reports',
			component: <div>Loading...</div>,
			icon: 'pi-id-card',
		},
		{
			id: 3,
			label: 'Admin Reports',
			component: <div>Loading...</div>,
			icon: 'pi-user',
		},
		{
			id: 4,
			label: 'Scheduled Reports',
			component: <div>Loading...</div>,
			icon: 'pi-calendar',
		},
		{
			id: 5,
			label: 'All Scheduled Reports',
			component: <div>Loading...</div>,
			icon: 'pi-calendar-plus',
		},
	]);

	const dispatch: Dispatch = useDispatch();

	const handleTabClick = (tabId: number) => {
		setActiveTab(tabId);
	};

	const loadReports = async () => dispatch(reportsActions.search());

	const formatReports = async () => {
		try {
			const result = await loadReports();
			const payload = result.payload;
			if (result.type === types.SEARCH_REPORTS_SUCCESS) {
				const generalTabs = [
					{
						id: 1,
						label: 'General Reports',
						component: <GeneralReports Reports={payload.userReports} disabled={false} />,
						icon: 'pi-chart-bar',
					},
					{
						id: 2,
						label: 'Moderator Reports',
						component: (
							<GeneralReports
								Reports={payload.moderatorReports}
								disabled={
									props.userRole !== CUSTOMER_ROLES.Owner.name &&
									props.userRole !== CUSTOMER_ROLES.Moderator.name &&
									props.userRole !== CUSTOMER_ROLES.Admin.name
								}
							/>
						),
						icon: 'pi-id-card',
					},
					{
						id: 3,
						label: 'Admin Reports',
						component: (
							<GeneralReports
								Reports={payload.adminReports}
								disabled={props.userRole !== CUSTOMER_ROLES.Owner.name && props.userRole !== CUSTOMER_ROLES.Admin.name}
							/>
						),
						icon: 'pi-user',
					},
					{
						id: 4,
						label: 'Scheduled Reports',
						component: <ScheduledReports all={false} />,
						icon: 'pi-calendar',
					},
				];

				if (props.userRole === CUSTOMER_ROLES.Owner.name) {
					generalTabs.push({
						id: 5,
						label: 'All Scheduled Reports',
						component: <ScheduledReports all={true} />,
						icon: 'pi-calendar-plus',
					});
				}

				setTabs(generalTabs);
			} else if (result.type === types.SEARCH_REPORTS_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	useEffect(() => {
		document.title = 'Reports';
		formatReports();
	}, []);

	return (
		<>
			<GlobalStyle />
			<PageWrapper>
				<ReportsPageTitle>Reports</ReportsPageTitle>
				<ReportsTab className='nav nav-tabs'>
					{tabs.map((tab) => (
						<li key={tab.id} className='nav-item'>
							<a className={`nav-link ${activeTab === tab.id ? 'active' : ''}`} onClick={() => handleTabClick(tab.id)}>
								<i className={`pi ${tab.icon}`} />
								<span>{tab.label}</span>
							</a>
						</li>
					))}
				</ReportsTab>
				{tabs.map((tab) => (
					<React.Fragment key={tab.id}>{activeTab === tab.id && tab.component}</React.Fragment>
				))}
			</PageWrapper>
		</>
	);
};

function mapStateToProps(state) {
	return {
		userRole: state.user.customerRole,
		userId: state.user.id,
	};
}

export default connect(mapStateToProps)(ReportsPage);
